<template>
  <b-card
    class="card-transaction grafico-view"
    no-body
  >
    <b-card-header>
      <b-card-title>Caixa postal</b-card-title>
    </b-card-header>
    <b-card-body>
      <div
        v-for="(transaction, $index) in totais"
        :key="$index"
        class="transaction-item"
        style="margin-bottom: 1.81rem"
        @click.prevent.stop="$router.push({
          name: 'caixapostal-view',
          query: {
            filtroRapido: transaction.query ? transaction.query : '',
            dataInicio: transaction.dataInicio ? transaction.dataInicio : '',
            filtroEmpresa: (filtros.empresas && filtros.empresas.length > 0) ? filtros.empresas : undefined
          }
        })"
      >
        <b-media no-body>
          <b-media-aside>
            <b-avatar
              rounded
              size="42"
              :variant="transaction.avatarVariant"
            >
              <feather-icon
                size="18"
                :icon="transaction.avatar"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="transaction-title">
              {{ transaction.titulo }}
            </h6>
            <small>{{ transaction.subTitulo }}</small>
          </b-media-body>
        </b-media>
        <div
          class="font-weight-bolder"
          :class="transaction.negativo ? 'text-danger':'text-success'"
        >
          {{ transaction.valor }}
        </div>
      </div>
    </b-card-body>

  </b-card>
</template>

<script>
import { defineComponent, watch } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
import useCaixaPostal from './useCaixaPostal'

export default defineComponent({
  components: {
    VueApexCharts,
    FontAwesomeIcon,
  },
  data() {
    return {
      filtros: {
        empresas: [],
      },
    }
  },
  created() {
    EventBus.$on('filtrosDashboardAtualizados', filtro => {
      this.filtros.empresas = filtro.empresas

      this.dados = useCaixaPostal(this.filtros)

      watch(
        () => this.dados.totaisCaixaPostal,
        newValue => {
          for (let index = 0; index < newValue.value.length; index += 1) {
            this.totais[index].valor = newValue.value[index].valor
          }
        },
        { immediate: true, deep: true },
      )
    })
  },
  setup() {
    const filtro = { empresas: [] }
    const { totaisCaixaPostal } = useCaixaPostal(filtro)

    return {
      totais: totaisCaixaPostal,
    }
  },
})
</script>
